import React from 'react';
type Stat = {
  value: string;
  label: string;
};
const STATS: Stat[] = [{
  value: '+300',
  label: 'Herramientas clínicas listas para usar'
}, {
  value: '+2.000',
  label: 'Médicos ya utilizan la metodología'
}, {
  value: '6',
  label: 'Tomos especializados'
}, {
  value: '100%',
  label: 'Digital • Descarga inmediata'
}];
export function StatsBar() {
  return <section aria-label="Cifras del Kit Clínico" className="w-full border-y border-navy-100 bg-white px-4 py-8" data-id="element-201" data-mp="1jeoj57wbe002">
      <div className="mx-auto grid max-w-4xl grid-cols-2 gap-y-7 gap-x-3 sm:grid-cols-4" data-id="element-202" data-mp="19mitw5xg5wok">
        {STATS.map(stat => <div key={stat.label} className="flex flex-col items-center text-center" data-id="element-203" data-mp="15k4ankpv8uwr">
            <span className="font-display text-3xl font-bold text-navy sm:text-4xl" data-id="element-204" data-mp="10m2sd209kzmc">
              {stat.value}
            </span>
            <span className="mt-1.5 max-w-[150px] text-[11px] font-semibold uppercase leading-snug tracking-wide text-navy/50 sm:text-xs" data-id="element-205" data-mp="vlokpl2krrou">
              {stat.label}
            </span>
          </div>)}
      </div>
    </section>;
}